module.exports = __webpack_public_path__ + "img/jjooJuventud2.80998abe.jpg";